import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-menu"
export default class extends Controller {
  static targets = [ "output", "current", "menu", "item" ]

  select_menu(item) {
    var template = item.querySelector("template")
    var clone = document.importNode(template.content, true)

    this.currentTarget.innerHTML = ""
    this.currentTarget.appendChild(clone)

    this.menuTarget.classList.remove("field_with_errors")

  }

  connect() {
    if(this.outputTarget.value) {
      this.itemTargets.forEach((element, index) => {
        if(element.dataset.itemId == this.outputTarget.value) {
          this.select_menu(element)
        }
      })
    }

    var errorTag = this.outputTarget.closest(".field_with_errors")
    console.log(errorTag)

    if(errorTag) {
      this.menuTarget.classList.add("field_with_errors")
    }
  }

  click() {
    this.outputTarget.value = event.currentTarget.dataset.itemId

    this.select_menu(event.currentTarget)
  }
}
